import { requestTranslateFunction } from '../utils/request-translate-function';
import { CREDENTIALS } from './_constants';
import { getFormattedBody } from './_utils/get-formatted-body';
import { getFormattedSchemas } from './_utils/get-formatted-schemas';
var ENDPOINT = '/ns/abac/suppliers-portal-core/';
export var makeRequestConfig = function (_a) {
    var features = _a.features, _b = _a.abortRequestId, abortRequestId = _b === void 0 ? '' : _b, endpoint = _a.endpoint, _c = _a.retry, retry = _c === void 0 ? 2 : _c, customTimeout = _a.customTimeout, browserCacheParams = _a.browserCacheParams;
    var credentials = Boolean(endpoint)
        ? CREDENTIALS.include
        : CREDENTIALS.default;
    return {
        endpoint: endpoint || ENDPOINT,
        translateFunction: requestTranslateFunction,
        responseSchema: getFormattedSchemas(features),
        abortRequestId: abortRequestId,
        body: getFormattedBody(features),
        isBatchRequest: true,
        retry: retry,
        notRetryWhenOffline: true,
        customTimeout: customTimeout,
        browserCacheParams: browserCacheParams,
        credentials: credentials,
    };
};
